import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import theme from '../../assets/style/theme';
import { menuWidth, handleWidth } from './sizes';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '../../screens';
import NavigationConstants from '../LobbyOverlay/NavigationConstants';
import audio from '../../utils/audio';
import { GAME_ROOMS } from '../../state/query/games/utils';
var SideMenu = /*#__PURE__*/function (_Component) {
  function SideMenu(props) {
    var _this;
    _classCallCheck(this, SideMenu);
    _this = _callSuper(this, SideMenu, [props]);
    _this.PanResponder = _this.props.panResponder;
    _this.Animated = _this.props.animated;
    _this._animateMenuOffset = -menuWidth;
    // responder
    _this._panResponder = _this.PanResponder.create({
      // Ask to be the responder:
      onStartShouldSetPanResponder: function onStartShouldSetPanResponder(evt, gestureState) {
        return false;
      },
      onStartShouldSetPanResponderCapture: function onStartShouldSetPanResponderCapture(evt, gestureState) {
        return false;
      },
      onMoveShouldSetPanResponder: function onMoveShouldSetPanResponder(evt, gestureState) {
        // return true if user is swiping, return false if it's a single click
        if (!_this.state.togglerDisabled) {
          return Math.abs(gestureState.vx) > 0.05;
        }
      },
      onMoveShouldSetPanResponderCapture: function onMoveShouldSetPanResponderCapture(evt, gestureState) {
        return false;
      },
      onPanResponderGrant: function onPanResponderGrant(evt, gestureState) {
        // The gesture has started. Show visual feedback so the user knows
        // what is happening!
        // gestureState.d{x,y} will be set to zero now
        _this.state.menuOffset.setOffset(_this._animateMenuOffset);
        _this.state.menuOffset.setValue(0);
      },
      onPanResponderMove: function onPanResponderMove(evt, gestureState) {
        // The most recent move distance is gestureState.move{X,Y}
        // The accumulated gesture distance since becoming responder is
        // gestureState.d{x,y}
        return _this.Animated.event([null, {
          dx: _this.state.menuOffset
        }], {
          useNativeDriver: false
        })(evt, gestureState);
      },
      onPanResponderTerminationRequest: function onPanResponderTerminationRequest(evt, gestureState) {
        return true;
      },
      onPanResponderRelease: function onPanResponderRelease(evt, gestureState) {
        // The user has released all touches while this view is the
        // responder. This typically means a gesture has succeeded
        _this.state.menuOffset.flattenOffset();
        var newExpanded = _this.state.expanded;
        if (gestureState.vx < -0.05) {
          newExpanded = false;
        }
        if (gestureState.vx > 0.05) {
          newExpanded = true;
        }
        _this.setState({
          expanded: newExpanded
        });
      },
      onPanResponderTerminate: function onPanResponderTerminate(evt, gestureState) {
        // Another component has become the responder, so this gesture
        // should be cancelled
      },
      onShouldBlockNativeResponder: function onShouldBlockNativeResponder(evt, gestureState) {
        // Returns whether this component should block native components from becoming the JS
        // responder. Returns true by default. Is currently only supported on android.
        return true;
      }
    });
    _this._handleTouched = function () {
      audio.onClick();
      _this.setState({
        expanded: !_this.state.expanded
      });
      return _this.state.menuOffset;
    };
    _this._navigationTouched = function (to) {
      audio.onClick();
      QueryParamsProxy.navigate(_this.props.navigation, to);
      QueryParamsProxy.updateURL();
      _this.setState({
        expanded: false
      });
    };
    _this._logoutTouched = function () {
      audio.onClick();
      _this.props.clearToken();
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Start);
    };
    _this._handleInformativeModal = function () {
      audio.onClick();
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.FavouritesInformation));
      QueryParamsProxy.updateURL();
    };
    _this.state = {
      menuOffset: new _this.Animated.Value(-menuWidth),
      expanded: false,
      renderFader: false,
      togglerDisabled: false
    };
    _this.tabRightPosition = new _this.Animated.Value(0);
    return _this;
  }
  _inherits(SideMenu, _Component);
  return _createClass(SideMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.state.menuOffset.addListener(function (value) {
        _this2._animateMenuOffset = value.value;
        if (value.value > -menuWidth && !_this2.state.renderFader) {
          _this2.setState({
            renderFader: true
          });
        }
        if (value.value <= -menuWidth && _this2.state.renderFader) {
          _this2.setState({
            renderFader: false
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.state.menuOffset.removeAllListeners();
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
      if (nextState.expanded != this.state.expanded || this.state.menuOffset != 0 || this.state.menuOffset != -menuWidth) {
        this.Animated.timing(this.state.menuOffset, {
          toValue: nextState.expanded ? -10 : -menuWidth,
          duration: 250,
          useNativeDriver: false
        }).start();
      }
      if (nextProps.sidebarState !== this.props.sidebarState) {
        this.setState({
          expanded: false
        });
      }
      if (nextProps.navState !== this.props.navState) {
        switch (nextProps.navState) {
          // we couple side menu's visibility with bottom bar's
          case NavigationConstants.HIDE_BOTTOM:
          case NavigationConstants.HIDE_BOTH:
            {
              this.setState({
                togglerDisabled: true,
                expanded: false
              });
              this.Animated.timing(this.tabRightPosition, {
                toValue: -handleWidth * 2.8,
                duration: 800,
                useNativeDriver: true
              }).start();
              break;
            }
          default:
            {
              this.setState({
                togglerDisabled: false
              });
              this.Animated.timing(this.tabRightPosition, {
                toValue: 0,
                duration: 800,
                useNativeDriver: true
              }).start();
            }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$sportsGam, _this$props$sportsGam2;
      var clampedMenuOffset = this.state.menuOffset.interpolate({
        inputRange: [-menuWidth, 0],
        outputRange: [-menuWidth, 0],
        extrapolateRight: 'clamp',
        extrapolateLeft: 'clamp'
      });
      var bgFade = this.state.menuOffset.interpolate({
        inputRange: [-menuWidth, 0],
        outputRange: [theme.palette.common[30], theme.palette.common[31]],
        extrapolateRight: 'clamp',
        extrapolateLeft: 'clamp'
      });
      return this.props.render({
        // Pass state and handlers to platform renderer
        // Platform specfic panResponder implementation
        panHandlers: this._panResponder.panHandlers,
        // Animated menu offset
        menuOffset: clampedMenuOffset,
        // Fade value for background
        bgFadeAmount: bgFade,
        // "Hack" to force a re-render
        bgFadeVisible: this.state.renderFader,
        // Handle pressed handler
        handleTouchedHandler: this._handleTouched,
        // Handle navigation touch
        navigationTouchHandler: this._navigationTouched,
        handleInformativeModal: this._handleInformativeModal,
        // Handle Logout
        logoutHandler: this._logoutTouched,
        userCanFavourite: this.props.userCanFavourite,
        expanded: this.state.expanded,
        // Nav state for side menu
        tabRightPosition: this.tabRightPosition,
        togglerDisabled: this.state.togglerDisabled,
        isVipRoomUnlocked: this.props.isVipRoomUnlocked,
        hasSportsRoom: ((_this$props$sportsGam = this.props.sportsGamesRoom) === null || _this$props$sportsGam === void 0 || (_this$props$sportsGam = _this$props$sportsGam.gameList) === null || _this$props$sportsGam === void 0 ? void 0 : _this$props$sportsGam.length) > 0,
        hasSportsRoomVip: ((_this$props$sportsGam2 = this.props.sportsGamesRoom) === null || _this$props$sportsGam2 === void 0 || (_this$props$sportsGam2 = _this$props$sportsGam2.gameList[0]) === null || _this$props$sportsGam2 === void 0 ? void 0 : _this$props$sportsGam2.source) === GAME_ROOMS.CONFIGURABLE_VIP,
        isAccountLinked: this.props.isAccountLinked,
        isBlockedForMissionsTutorial: this.props.isBlockedForMissionsTutorial
      });
    }
  }]);
}(Component);
export { SideMenu as default };